import { useEffect } from "react";
import { useRouter } from "next/navigation"; 
import ROUTES from "../../routes";
import Page from "@/components/template-parts/page";
import DBService from "@/util/db-service";
import useUser from "@/lib/useUser";
import WillManager from "@/components/views/will-manager/will-manager";
import ContentProvider from "@/providers/content-provider";
import type { PageProps } from "@/types";

export const getStaticProps = async () => {
    return { props: { content: await DBService.getPage(ROUTES.WILL.MANAGE) } as PageProps };
}
const Handler = ( props: PageProps ) => {

    const { authUser, isLoading } = useUser();

    const router = useRouter();

    // Redirect if not authenticated
    useEffect( () => {
        if ( ! isLoading && authUser === null ) {
            router.push(`${ROUTES.AUTH.BASE}?redirect=${ROUTES.WILL.MANAGE}`);
        }
    }, [isLoading, authUser]); 


    return(
        <ContentProvider content={props.content} >
            <Page title="Poista hautajaistestamentti" type="will" loading={ ! authUser || isLoading} authUser={authUser}>
                <WillManager willType="WILL" user={authUser} />
            </Page>
        </ContentProvider>
    )
}

export default Handler;